















import { Component, Vue } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import * as JobsAPI from '@/api/jobsApi';
import JobDetails from '@/components/jobDetail/JobDetails.vue';
import { JobUserStatusEnum } from '@/types/jobUserStatus';

@Component({
  components: {
    JobDetails
  }
})
export default class ViewJob extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private job: Job = null;
  
  created() {
    this.init();
  }

  async init(){
    this.loading = true;

    try {
      this.job = await JobsAPI.getJob(this.$route.params.jobID);

      console.log(this.job)

      // if(!this.job.assignment.take5SafetyComplete){
      //   // console.log('should be pushed to the take5 form')
      //   // go the to take5 safety form (replace current route so the back button functions as expected)
      //   this.$router.replace({ name: 'viewjobtake5', params: { jobID: this.job.id }});
      // }

      if(!this.job.assignment.riskMatrixSignedOff && this.job.assignment.latestStatus.status.id === JobUserStatusEnum.START_CONTINUE_WORK){
        this.$router.push({ name: 'viewjobserviceform', params: { jobID: this.job.id } });
      }

      if(!this.job.clientSignoff && this.job.assignment.latestStatus.status.id === JobUserStatusEnum.FINISH_WORK){
        this.$router.push({ name: 'viewjobserviceform', params: { jobID: this.job.id } });
      }
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

